import React from "react";
import { useNavigate } from "react-router-dom";

export default function Header({ title }) {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <button style={styles.backBtn} onClick={() => navigate(-1)}>◀</button>
      <h2 style={styles.title}>{title}</h2>
    </div>
  );
}

const styles = {
  container: {
    background: "#E30016",
    color: "white",
    padding: "1rem",
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  backBtn: {
    background: "white",
    color: "#E30016",
    border: "none",
    padding: "8px 12px",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  title: {
    margin: 0,
  },
};
